import BreadCrumb from 'components/Common/BreadCrumb';
import LabelWrapper from 'components/Common/LabelWrapper';
import { useRole } from 'components/Hooks/UserHooks';
import RangeDatePicker from 'components/pickers/RangeDatePicker';
import moment from "moment";
import NestingFilter from 'pages/News/Components/NestingFilter';
import React, { useCallback, useEffect, useState } from "react";
import CountUp from 'react-countup';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import { createSelector } from 'reselect';
import { ROUTES } from 'routes/allRoutes';
import { NumberParam, StringParam, useQueryParams, withDefault, } from "use-query-params";
import { getListRealTimeKeywordRecommend as onGetRealTimeKeywordRecommends } from "../../../store/thunks";
import IconDown from '../Icons/IconDown';
import IconLine from '../Icons/IconLine';
import IconUp from '../Icons/IconUp';
import { isHavePermissionRole } from 'helpers/role';
import { ROLES_FOR_APP } from 'helpers/role';

export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'pa_index';

const RecommendRealTimeKeywordList = () => {

  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    // page: withDefault(NumberParam, 1),
    // limit: withDefault(NumberParam, 100),
    // sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    // order_by: withDefault(StringParam, 'DESC'),
    date: withDefault(StringParam, `${moment().format("Y-MM-DD")}`),
    keyword: withDefault(StringParam, ''),
    // section: withDefault(StringParam, `${SECTION_KEYWORD.BOOSTING}`),
  });

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

  const [dateSearch, setDateSearch] = useState<any>(query?.date ? moment(query?.date, 'Y-MM-DD').toDate() : null);

  const [optionsSelected, setOptionsSelected] = useState<any>([]);

  const [sectionsShow, setSectionsShow] = useState<number[]>([]);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.Keyword;

  const KeywordProperties = createSelector(
    selectLayoutState,
    (state) => ({
      realTimeKeywordRecommends: state.realTimeKeywordRecommends,
      isRealTimeKeywordRecommendSuccess: state.isRealTimeKeywordRecommendSuccess,
      isRealTimeKeywordRecommendLoading: state.isRealTimeKeywordRecommendLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { realTimeKeywordRecommends, isRealTimeKeywordRecommendLoading } = useSelector(KeywordProperties);


  useEffect(() => {
    dispatch(onGetRealTimeKeywordRecommends(query));
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    const queryNew = {
      ...query,
      date: dateSearch ? moment(new Date(dateSearch)).format("Y-MM-DD") : '',
      keyword: keywordSearch || '',
      // section: `${SECTION_KEYWORD.BOOSTING}`,
      page: 1,
      time_request: + new Date()
    };
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      keyword: '',
      // section: `${SECTION_KEYWORD.BOOSTING}`,
      date: `${moment().format("Y-MM-DD")}`,
      sort_by: TYPE_SELECT_DEFAULT,
      order_by: 'DESC',
      page: 1,
      time_request: + new Date(),
    };
    setQuery(queryNew, "push");
    setKeywordSearch((_prev) => "");
    setDateSearch(queryNew?.date ? moment(queryNew?.date || "", 'Y-MM-DD').toDate() : null);
  };

  const handleChangeDatePicker = (date: any) => {
    setDateSearch((_prev: any) => date);
  }

  useEffect(() => {
    document.title = `${t('Recommend Real-time Keyword')} | ${t('PRESS Ai')}`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  const renderLinkNavigateToIANews = useCallback((date: string = '', section: number, keyword: string = '') => {
    const isHave = isHavePermissionRole(ROLES_FOR_APP.AI_NEWS, userPermissions);
    return isHave ? `${ROUTES.AI_NEWS}?section=${section || ''}&keyword=${keyword || ''}&start_date=${date || ''}&end_date=${date || ''}` : '#';
  }, []);

  const handleCheckSectionShow = (_number_section: number) => {
    setSectionsShow((_prev) => {
      if (_prev?.includes(_number_section)) {
        return _prev?.filter((_p) => _p !== _number_section);
      }
      return [..._prev, _number_section];
    })
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Recommend Real-time Keyword')} pageTitle={t('Recommend Keyword')} />
          <Row className="h-auto-custom">
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-6">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          {isRealTimeKeywordRecommendLoading ? (
                            <Spinner
                              size="sm"
                              className="text-primary"
                            ></Spinner>
                          ) : (
                            <CountUp
                              start={0}
                              end={realTimeKeywordRecommends?.length || 0}
                              duration={1}
                              className="text-primary"
                            />
                          )}
                        </h5>
                      </div>
                    </div>
                    <div className="col-6 text-end">

                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4 px-0 px-lg-3 pt-0 pt-lg-3">
                  <NestingFilter>
                    <Row className="g-4 align-items-end mt-0">
                      <Col
                        sm={6}
                        md={6}
                        lg={4}
                        xl={4}
                        xxl={2}
                        className="mt-3 mt-lg-2"
                      >
                        <LabelWrapper
                          label={t("Keyword")}
                          isShow={!!keywordSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Keyword")}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={6}
                        md={6}
                        lg={4}
                        xl={4}
                        xxl={2}
                        className="date-picker-wrapper-custom mt-3 mt-lg-2"
                      >
                        <LabelWrapper label={t('Date')} isShow={!!dateSearch}>
                          <RangeDatePicker
                            maxDate={moment().toDate()}
                            dateSearch={dateSearch}
                            handleChangeDatePicker={handleChangeDatePicker}
                          />
                        </LabelWrapper>
                      </Col>
                      <Col
                        sm={6}
                        md={12}
                        lg={4}
                        xl={4}
                        xxl={8}
                        className="hstack gap-1 justify-content-center justify-content-sm-end justify-content-lg-start mt-3 mt-lg-2"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-2 me-lg-2"
                            onClick={searchData}
                            disabled={isRealTimeKeywordRecommendLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </NestingFilter>
                </div>
                <CardBody className="" style={{ minHeight: '90dvh' }}>
                  <Row>
                    {(realTimeKeywordRecommends || [])?.map((sectionKeyword: any, indexSection: number) => (
                      <Col sm={6} md={4} lg={4} xl={4} xxl={3} key={sectionKeyword?.section}>
                        <div className="card-height-100 card">
                          <div className="align-items-center d-flex card-header bg-info-subtle">
                            <Link className="nav-link cursor-pointer hover-underline text-info" to={renderLinkNavigateToIANews(query?.date, sectionKeyword?.section)}>
                              <h4 className="card-title mb-0 flex-grow-1 text-info">{sectionKeyword?.section_name || ''}</h4>
                            </Link>
                          </div>
                          <div className="card-body">
                            <div className="table-responsive table-card " style={{ height: '450px', overflowY: 'auto' }}>
                              <table className="table align-middle table-borderless table-centered table-hover table-nowrap mb-0">
                                <thead className="" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f5f9ff', }}>
                                  <tr>
                                    <th scope="col" className="py-2 text-center fw-medium" style={{ width: '70px' }}>{t('Rank')}</th>
                                    <th scope="col" className="py-2 ps-4 ps-xxl-5 fw-medium">{t('Keyword')}</th>
                                    <th scope="col" className="py-2 text-center fw-medium" style={{ width: '40px' }}></th>
                                  </tr>
                                </thead>
                                <tbody style={{}}>
                                  {(sectionKeyword?.keywords || []).slice(0, 10)?.map((itemKeyword: any, indexRow: number) => (
                                    <tr key={itemKeyword?.rank}>
                                      <td className={`py-2 text-center ${indexRow < 3 ? 'fw-bold text-info' : ''}`} >
                                        {itemKeyword?.rank || '-'}
                                      </td>
                                      <td className="py-2 ps-4 ps-xxl-5" >
                                        <Link className="nav-link cursor-pointer hover-underline bold" to={renderLinkNavigateToIANews(query?.date, sectionKeyword?.section, itemKeyword?.keyword)}>{itemKeyword?.keyword || '-'}</Link>
                                      </td>
                                      <td className="text-end py-2">{Number(itemKeyword?.diff_rank) > 0 ? <IconUp /> : (Number(itemKeyword?.diff_rank) < 0 ? <IconDown /> : <IconLine />)}</td>
                                    </tr>
                                  ))}
                                  {(sectionKeyword?.keywords?.length > 10 && !!sectionsShow?.includes(indexSection)) &&
                                    <>
                                      {
                                        (sectionKeyword?.keywords || []).slice(10)?.map((itemKeyword: any) => (
                                          <tr key={itemKeyword?.rank}>
                                            <td className="py-2 text-center" >
                                              {itemKeyword?.rank || '-'}
                                            </td>
                                            <td className="py-2 ps-4 ps-xxl-5" >
                                              <Link className="nav-link cursor-pointer hover-underline bold" to={renderLinkNavigateToIANews(query?.date, sectionKeyword?.section, itemKeyword?.keyword)}>{itemKeyword?.keyword || '-'}</Link>
                                            </td>
                                            <td className="text-end py-2">{Number(itemKeyword?.diff_rank) > 0 ? <IconUp /> : (Number(itemKeyword?.diff_rank) < 0 ? <IconDown /> : <IconLine />)}</td>
                                          </tr>
                                        ))
                                      }
                                    </>
                                  }
                                  {(sectionKeyword?.keywords?.length > 10) && <tr>
                                    <td colSpan={3} onClick={() => handleCheckSectionShow(indexSection)} className="py-2">
                                      <div className="text-center text-info cursor-pointer">{!sectionsShow?.includes(indexSection) ? <> {t('See More')} <i className="ri-arrow-down-s-line align-middle" /> </> : <>{t('See Less')} <i className=" ri-arrow-up-s-line align-middle" /></>}</div>
                                    </td>
                                  </tr>}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />
      </div >
    </React.Fragment >
  );
};

export default RecommendRealTimeKeywordList;